import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { RadioButtonSimpleField } from 'components/FormFieldsSimple/RadioButtonSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class RadioButtonField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
      }),
    ).isRequired,
    columnsCount: PropTypes.number,
  };

  static defaultProps = {
    columnsCount: 1,
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
  };

  render() {
    const { input } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <RadioButtonSimpleField
          {...this.props}
          onChange={this.handleChange}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
